module.exports = __webpack_public_path__ + "img/Body_feathers_Normal.fe81a5d.png";